import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Card,
  Spinner,
  Alert,
  ListGroup,
  Button,
  Row,
  Col,
} from "react-bootstrap";
import api from "../../services/api";
import { formataDataHoraExibicao, getCurrentUser } from "../../common/utils";
import { isSuperUser } from "../../common/userUtils";
import { FaTrash } from "react-icons/fa";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import StatusBadge from "./StatusBadge";
import { excluirReporteFarmaco } from "./excluirReporte";

const DetalheReporte = () => {
  const { reporteId } = useParams();
  const navigate = useNavigate();
  const [reporte, setReporte] = useState(null);
  const [loading, setLoading] = useState(true);
  // guarda a chave da mensagem; é traduzida no render
  const [error, setError] = useState("");
  const { t } = useTranslation(["reportesFarmaco", "common"]);

  const dados_usuario = getCurrentUser();
  const isNavegadora = dados_usuario.tipo_usuario === "operador";
  const podeExcluir = isSuperUser(dados_usuario);

  useEffect(() => {
    const fetchReporte = async () => {
      try {
        const response = await api.get(`/formularios/respostas/${reporteId}/`);
        setReporte(response.data);
      } catch (err) {
        console.error("Erro ao buscar detalhes do reporte:", err);
        setError("reportesFarmaco:detalhe.loadError");
      } finally {
        setLoading(false);
      }
    };

    fetchReporte();
  }, [reporteId]);

  const handleCriarCopia = () => {
    const promise = () =>
      new Promise((resolve, reject) => {
        api
          .post(`/formularios/respostas/${reporteId}/derivar/`)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });

    toast.promise(promise, {
      loading: t("reportesFarmaco:detalhe.copy.loading"),
      success: (response) => {
        navigate(`/reportes-farmaco/editar/${response.data.id}`);
        return t("reportesFarmaco:detalhe.copy.success");
      },
      error: (err) => {
        const errorMessage =
          err.response?.status === 409
            ? t("reportesFarmaco:detalhe.copy.exists")
            : t("reportesFarmaco:detalhe.copy.error");
        return errorMessage;
      },
    });
  };

  const handleExcluirReporte = async () => {
    const excluido = await excluirReporteFarmaco(reporte);
    if (excluido) {
      navigate("/reportes-farmaco");
    }
  };

  if (loading) {
    return (
      <div className="text-center p-5">
        <Spinner animation="border" />
      </div>
    );
  }

  if (error) {
    return <Alert variant="danger">{t(error)}</Alert>;
  }

  const nomePaciente =
    reporte.dados_beneficiario?.nome ||
    reporte.respostas?.paciente_nome_iniciais ||
    "-";

  return (
    <div>
      <Row className="align-items-center">
        <Col sm={6} lg={6}>
          <h4 className="page-title">
            {t("reportesFarmaco:detalhe.pageTitle", { id: reporte?.id })}
          </h4>
        </Col>
      </Row>
      <Card className="cardDestaque">
        <Card.Body>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <strong>{t("reportesFarmaco:detalhe.sentDate")}</strong>{" "}
              {formataDataHoraExibicao(reporte.data_cadastro)}
            </ListGroup.Item>
            <ListGroup.Item>
              <strong>{t("reportesFarmaco:detalhe.status")}</strong> <StatusBadge status={reporte.status} />
            </ListGroup.Item>
            <ListGroup.Item>
              <strong>{t("reportesFarmaco:detalhe.provider")}</strong>{" "}
              {reporte.dados_prestador?.nome || `ID ${reporte.prestador_id}`}
            </ListGroup.Item>
            <ListGroup.Item>
              <strong>{t("reportesFarmaco:detalhe.program")}</strong>{" "}
              {reporte.dados_programa?.nome || `ID ${reporte.programa_id}`}
            </ListGroup.Item>

            <ListGroup.Item>
              <strong>{t("reportesFarmaco:detalhe.patient")}</strong> {nomePaciente}
            </ListGroup.Item>
            <ListGroup.Item>
              <strong>{t("reportesFarmaco:detalhe.encounter")}</strong>{" "}
              {reporte.dados_atendimento?.id || "-"}
            </ListGroup.Item>
          </ListGroup>

          <h6 className="mt-4">{t("reportesFarmaco:detalhe.answers")}</h6>
          <ListGroup variant="flush">
            {reporte.respostas &&
              Object.entries(reporte.respostas).map(([slug, valor]) =>
                slug === "paciente_nome_iniciais" &&
                reporte.dados_beneficiario ? null : (
                  <ListGroup.Item key={slug}>
                    <strong>
                      {slug
                        .replace(/_/g, " ")
                        .replace(/\b\w/g, (l) => l.toUpperCase())}
                      :
                    </strong>
                    <p style={{ whiteSpace: "pre-wrap", margin: 0 }}>{valor}</p>
                  </ListGroup.Item>
                )
              )}
          </ListGroup>
        </Card.Body>
        <Card.Footer className="text-end">
          {/*isNavegadora && reporte.status === "enviado" && (
            <Button variant="info" onClick={handleCriarCopia}>
              Iniciar Análise (Criar Cópia)
            </Button>
          )*/}
          {podeExcluir && (
            <Button
              variant="danger"
              size="sm"
              onClick={handleExcluirReporte}
            >
              <FaTrash /> {t("reportesFarmaco:detalhe.delete")}
            </Button>
          )}
          <Button
            variant="secondary"
            size="sm"
            className="ms-2"
            onClick={() => navigate("/reportes-farmaco")}
          >
            {t("reportesFarmaco:detalhe.back")}
          </Button>
        </Card.Footer>
      </Card>
    </div>
  );
};

export default DetalheReporte;
